<template>
    <zeit-prompt v-if="showPrompt" @close="hidePrompt()" ref="prompt" desktopCloseLabel="Schließen" :enableClose="timeUntil(institution.license.restriction_date, true).days + 1 >= 0" maxWidth="max-w-2xl">
        <template #title>Abgelaufene Lizenz</template>
  
        <div class="flex flex-col mb-8 mt-4">
          <p class="mb-4">
            Deine Lizenz für {{ brand.name }} ist seit dem <span class="font-semibold">{{ formatDatetime(institution.license.valid_until) }}</span> abgelaufen. Um weiterhin uneingeschränkt auf alle Funktionen zugreifen zu können, kontaktiere bitte deinen Fachhändler und verlängere deine Lizenz.
          </p>

          <p class="font-semibold mb-4">Wichtig:</p>

          <ul class="list-disc list-outside ml-5 mb-4">
            <template v-if="timeUntil(institution.license.restriction_date, true).days + 1 < 0">
              <li>Der Zugang für Administratoren und Abteilungsleiter ist gesperrt. Mitarbeiter können Arbeitszeiten zunächst weiterhin erfassen.</li>              
            </template>
            <template v-else>
              <li>Du kannst das System noch für <span class="font-semibold">{{ timeUntil(institution.license.restriction_date, true).days + 1 }} Tage</span> bis zum <span class="font-semibold">{{ formatDatetime(institution.license.restriction_date) }}</span> nutzen.</li>
              <li>Nach Ablauf dieser Frist wird der Zugang für Administratoren und Abteilungsleiter gesperrt. Mitarbeiter können Arbeitszeiten zunächst weiterhin erfassen.</li>
            </template>
            <li v-if="timeUntil(institution.license.deletion_date, true).days + 1 > 0">Das Konto inklusive aller Nutzerdaten wird in <span class="font-semibold">{{ timeUntil(institution.license.deletion_date, true).days + 1 }} Tagen</span>  zum <span class="font-semibold">{{ formatDatetime(institution.license.deletion_date) }}</span> unwiderruflich gelöscht.</li>
            <li v-else>Das Konto wird in Kürze unwiderruflich gelöscht.</li>
          </ul>

          <div class="mb-4">
            Bei Fragen oder Problemen steht dir unser <a href="mailto:zeit@service.eins.io" class="text-primary-dark font-semibold">Support-Team</a> gerne zur Verfügung.
          </div>

          <div class="mb-4">Wir danken dir für dein Verständnis und deine Kooperation.</div>

          <div class="mb-4 font-semibold">
            Dein Team von {{ brand.name }}
          </div>

          <template v-if="timeUntil(institution.license.restriction_date, true).days + 1 >= 0">
            <div class="mb-2">Dieser Hinweis wird dir einmalig pro Tag angezeigt.</div>
          </template>


        </div>
        
        <template #footer>
          <div class="bg-primary text-white -mx-2 -mb-6 px-6 py-4 font-semibold rounded-b-xl flex cursor-pointer" @click="logout()">
            <div>Du hast mittlerweile eine neue Lizenz gekauft? Logge dich erneut ein, um diese zu aktivieren &rarr;</div>
          </div>
        </template>
      </zeit-prompt>
</template>
  
  <script lang="ts">
    import { defineComponent } from 'vue';
  
    import ZeitCard from '@/components/ui/v2/ZeitCard.vue';
    import ZeitCardItem from '@/components/ui/v2/ZeitCardItem.vue';
    import ZeitPrompt from '@/components/ui/ZeitPrompt.vue';

    import { session } from '@/globals/session';
    import { formatDatetime, timeUntil } from '@/globals/helpers';
    import brand from '@/branding';
    import { accountService } from '@/services/accounts';
  
    export default defineComponent({
      components: {
        ZeitCard, ZeitCardItem, ZeitPrompt,
      },
      data() {
        return {
          showPrompt: false,
          institution: session.institution,
        }
      },
      setup() {
        return {
          formatDatetime,
          timeUntil,
          brand,
        }
      },
      methods: {
        getLocalStorageKey() {
          return `licensePrompt__${localStorage.accessToken.slice(0, 4)}`;
        },
        hidePrompt() {
          this.showPrompt = false;
          localStorage.setItem(this.getLocalStorageKey(), new Date().toISOString());
        },
        logout() {
          this.hidePrompt();
          accountService.logout();
          this.$router.replace({name:'authentication:login'});
        },
      },
      mounted() {
        if (!this.institution || !this.institution.license || !this.institution.license.expired) return;
        if (brand.id != 'black') return;

        const lastPrompt = localStorage.getItem(this.getLocalStorageKey());
        if (lastPrompt && new Date(lastPrompt).getDate() == new Date().getDate()) return;

        this.showPrompt = true;
      },
    })
  </script>
  